module.exports = __webpack_public_path__ + "static/Elektro viljuškari-4863a37ad7514e19aed31190f82c8a50.pdf";